import React, { useCallback, useMemo, useState } from 'react'
import {
  Dropdown,
  Button,
  Field,
  NumberField,
  Checkbox,
} from '@groovehq/internal-design-system/lib/components'
import { list } from '@groovehq/internal-design-system/lib/styles/elements'
import { styles } from './styles'

const defaultAdditional = {
  taxable: true,
  requireShipping: false,
}

const CustomItem = ({ currency }) => {
  const [additional] = useState(defaultAdditional)
  const [visible] = useState(false)
  const btnDisabled = true
  const handleSave = () => {
    // TODO
  }
  const handleCancel = useCallback(() => {
    // TODO
  }, [])
  const handleFieldChange = useCallback(() => {
    // TODO
  }, [])
  const handleInputBlur = useCallback(() => {
    // TODO
  }, [])
  const handleAdditionalChange = useCallback(() => {
    // TODO
  }, [])
  const footer = (
    <>
      <Button type="tertiary" size="small" onClick={handleCancel}>
        Cancel
      </Button>
      <Button size="small" disabled={btnDisabled} onClick={handleSave}>
        Save line item
      </Button>
    </>
  )

  const overlay = useMemo(
    () => {
      return (
        <div className="grui px-7 py-6" css={styles.overlay}>
          <ul className="grui mb-10" css={list.styles.preflight}>
            <li>
              <Field onChange={handleFieldChange} onBlur={handleInputBlur} />
            </li>
            <li>
              <Field
                onChange={handleFieldChange}
                onBlur={handleInputBlur}
                tagPosition="left"
                tagContent={currency}
              />
            </li>
            <li>
              <NumberField
                tagPosition="left"
                tagContent={currency}
                onChange={handleFieldChange}
                onBlur={handleInputBlur}
              />
            </li>
          </ul>
          <Checkbox
            id="item-taxable"
            className="grui mb-5"
            value="taxable"
            checked={additional.taxable}
            onChange={handleAdditionalChange}
          >
            Item is taxable
          </Checkbox>
          <Checkbox
            id="item-shipping"
            value="requireShipping"
            checked={additional.requireShipping}
            onChange={handleAdditionalChange}
          >
            Item requires shipping
          </Checkbox>
        </div>
      )
    },
    [
      additional.requireShipping,
      additional.taxable,
      currency,
      handleAdditionalChange,
      handleFieldChange,
      handleInputBlur,
    ]
  )

  const handleVisibleChange = () => {
    // TODO
  }

  return (
    <Dropdown
      overlay={overlay}
      footer={footer}
      footerWithBtns
      hasMinWidth
      autoHeight
      visible={visible}
      onVisibleChange={handleVisibleChange}
    >
      <Button type="tertiary" size="small" className="grui ml-5">
        Add custom item
      </Button>
    </Dropdown>
  )
}

// CustomItem.propTypes = {
//   currency: string,
// }

// CustomItem.defaultProps = {
//   currency: '',
//   onAddItem() {},
// }

export default CustomItem
